define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'readingiq-src/js/riq-js/riq-error-handler-service/1.0.0/index-impl',
  'core_client_library/js/aofl-js/0.6.0/aofl-log/0.1/index'
  /* eslint-enable */
], function service(app, riqErrorHandlerServiceImpl) {
  'use strict';

  app.registerFactory('riqErrorHandlerService', [
    '$state',
    'aoflLog',
    'applicationDebug',
    riqErrorHandlerServiceImpl
  ]);
});
